import ApiMakerTable from "shared/api-maker-table"
import BaseComponent from "components/base-component"
import classNames from "classnames"
import {ContentPieceType} from "models"
import ContentPieceTypeLink from "components/content-piece-types/link"
import linkProps from "shared/link-props"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default class ComponentsContentPieceTypes extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {columns, editModelPath, viewModelPath} = this.t
    const {adminLayout, className, userLayout, ...restProps} = this.props

    return (
      <ApiMakerTable
        className={classNames("components--content-piece-types--table", className)}
        columns={columns}
        editModelPath={editModelPath}
        modelClass={ContentPieceType}
        select={{ContentPieceType: ["id", "name"]}}
        viewModelPath={viewModelPath}
        {...restProps}
      />
    )
  }

  columns = () => [
    {
      attribute: "id",
      defaultVisible: false,
      sortKey: "id"
    },
    {
      content: this.t.contentPieceTypeContent,
      label: ContentPieceType.humanAttributeName("name"),
      sortKey: "currentTranslationName"
    },
    {
      attribute: "icon",
      sortKey: "icon"
    },
    {
      attribute: "showOnDigitalClassRoom",
      sortKey: "showOnDigitalClassRoom"
    }
  ]

  editModelPath = ({contentPieceType}) => {
    if (this.p.adminLayout) return Routes.editAdminContentPieceTypePath(contentPieceType.id())
  }

  viewModelPath = ({contentPieceType}) => {
    if (this.p.adminLayout) return Routes.adminContentPieceTypePath(contentPieceType.id())
  }

  contentPieceTypeContent = ({contentPieceType}) => <ContentPieceTypeLink contentPieceType={contentPieceType} {...linkProps(this.props)} />
}
